import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {TumbleSymbolInfo} from '@gongxigames/framework/slotV2/modules/tumbleReels/TumbleReelsService';

export const tumbleReelsStore = Store.createStore({
    tumbleSymbolInfo: Store.signal<TumbleSymbolInfo[]>([])
});